import { render, staticRenderFns } from "./ModalAlertUnsaved.vue?vue&type=template&id=49ec41e6&"
import script from "./ModalAlertUnsaved.vue?vue&type=script&lang=js&"
export * from "./ModalAlertUnsaved.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertUnsaved.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports